function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useWizard } from 'react-use-wizard';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { Button } from '../../../../components/button';
import Control from '../../../../components/form/Control';
import text from '../../../../text';
import { onboardingConstants } from './constants';
import { useOnboarding } from './reducer';
var onboardingSchema = yup.object({
    fullName: yup.string().required(),
    phoneNumber: yup.string().required()
});
var Welcome = function() {
    var _useOnboarding = _sliced_to_array(useOnboarding(), 2), _useOnboarding_ = _useOnboarding[0], fullName = _useOnboarding_.fullName, phoneNumber = _useOnboarding_.phoneNumber, dispatch = _useOnboarding[1];
    var nextStep = useWizard().nextStep;
    var handleSubmit = function(param) {
        var fullName = param.fullName, phoneNumber = param.phoneNumber;
        dispatch({
            type: onboardingConstants.SET_FULL_NAME,
            payload: fullName
        });
        dispatch({
            type: onboardingConstants.SET_PHONE_NUMBER,
            payload: phoneNumber
        });
        nextStep();
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal.Header, null, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column align-items-center flex-fill"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "text-center w-100 mb-1 font-24"
    }, text('enterDetails')), /*#__PURE__*/ React.createElement("h6", {
        className: "secondary-heading"
    }, text('tellUsAboutYourself')))), /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "pt-0"
    }, /*#__PURE__*/ React.createElement(Formik, {
        initialValues: {
            fullName: fullName,
            phoneNumber: phoneNumber
        },
        validationSchema: onboardingSchema,
        onSubmit: handleSubmit,
        validateOnChange: true,
        validateOnMount: true
    }, function(param) {
        var values = param.values, errors = param.errors, touched = param.touched, isSubmitting = param.isSubmitting, handleChange = param.handleChange, dirty = param.dirty, isValid = param.isValid;
        return /*#__PURE__*/ React.createElement(Form, {
            className: "form"
        }, /*#__PURE__*/ React.createElement(Control, {
            required: true,
            type: "text",
            name: "fullName",
            label: text('fullName'),
            value: (values === null || values === void 0 ? void 0 : values.fullName) || '',
            onChange: handleChange,
            autoComplete: "off",
            isFailed: touched.fullName && !!errors.fullName ? true : false,
            isSuccessful: !errors.fullName,
            validationError: errors.fullName,
            placeholder: text('fullNamePlaceholder')
        }), /*#__PURE__*/ React.createElement(Control, {
            required: true,
            type: "text",
            name: "phoneNumber",
            label: text('phoneNumber'),
            value: (values === null || values === void 0 ? void 0 : values.phoneNumber) || '',
            onChange: handleChange,
            autoComplete: "off",
            isFailed: touched.phoneNumber && !!errors.phoneNumber ? true : false,
            isSuccessful: !errors.phoneNumber,
            validationError: errors.phoneNumber,
            placeholder: text('phoneNumberPlaceholder')
        }), /*#__PURE__*/ React.createElement(Button, {
            type: !isSubmitting && 'submit',
            disabled: !(dirty && isValid),
            className: "submit-button btn-block w-100"
        }, text('nextStep')));
    })));
};
export default Welcome;
